import React from 'react'

export default function Avatar() {

    return (
        <div  ><img src={window.location.origin + "/images/fab-icon/favicon-32x32.png"}></img></div>
    )
}
